import { FC, Fragment } from 'react'
import styles from './MembersEveryDay.module.scss'
import { Img } from 'components/basic/Img'
import { Slider2023 } from 'components/WebEv/Slider2023'
import { Theme } from 'components/_utils/utilityTypes'
import { Button } from 'components/WebEv/Buttons'

export interface MembersEveryDayProps {
	title?: string
}

export const MembersEveryDay: FC<MembersEveryDayProps> = (props) => {
	return (
		<div className={styles.container}>
			<h2>{props.title ?? 'Members sleeping better everyday'}</h2>

			<div className={styles.desktop_gallery}>
				<ul>
					{cards.map((card, i) => (
						<li key={i}>
							<Card {...card} />
						</li>
					))}
				</ul>
			</div>
			<div className={styles.mobile_slider}>
				<Slider2023
					theme={Theme.LIGHT}
					settings={{ slidesToShow: 1.2, autoplay: false, dots: false, arrows: false }}
				>
					{cards.map((card, i) => (
						<Fragment key={i}>
							<Card {...card} />
						</Fragment>
					))}
				</Slider2023>
			</div>
			<div className={styles.cta_container}>
				<Button.TextLink
					id={'wheel-cta'}
					href={'/wall-of-love/'}
				>
					View more stories
				</Button.TextLink>
			</div>
		</div>
	)
}

const cards: CardProps[] = [
	{
		src: 'https://eightsleep.imgix.net/Marques_Brownlee_cropped.jpg?v=1689972211',
		name: 'Marques Brownlee',
		caption: 'Tech Reviewer',
		quote: "In an age where humans are sleeping worse than ever... it's pretty cool to have...",
	},
	{
		src: 'https://eightsleep.imgix.net/IMG_9384-scaled-e1666058826274-5.jpg?v=1690923926',
		name: 'Elissa Goodman',
		caption: 'Nutritionist',
		quote: 'I used to suffer from regular night sweats… I haven’t since putting it on my mattress.',
	},
	{
		src: 'https://eightsleep.imgix.net/IMG-20220905-WA0005_-_Trevor_Whyte_83d7c836-785c-410d-882f-543d9e0af899.jpg?v=1691078418',
		name: 'Trevor Whyte',
		caption: 'Respiratory Therapist',
		quote: 'No strategy, supplement or tool has improved my wellness the way this product has.',
	},

	{
		src: 'https://eightsleep.imgix.net/6B1A3155.jpg?v=1689972212',
		name: 'Sami Clarke',
		caption: 'Fitness trainer',
		quote: 'The mattress cover has changed my life…it is an investment I’m so grateful for.',
	},
]

interface CardProps {
	src: string
	name: string
	quote: string
	caption: string
}

const Card: FC<CardProps> = (props) => (
	<div className={styles.card}>
		<Img
			src={props.src}
			alt={props.name}
			className={styles.card_img}
			objectFit={'cover'}
			dprHeight={1000}
		/>
		<div className={styles.shade} />

		<div className={styles.text_content}>
			<h4>“{props.quote}”</h4>

			<strong>{props.name}</strong>
			<p>{props.caption}</p>
		</div>
	</div>
)
